module.exports = __webpack_public_path__ + "static/img/water_dissolved_oxygen.7d6def3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/water_dissolved_oxygen.png
// module id = octh
// module chunks = 1